import { required } from 'utils/validation'

export default function(values = {}) {
  const errors = {}

  errors.questionText = required(values.questionText)

  if (values.questionOptions) {
    const questionsArrayErrors = []

    values.questionOptions.forEach((question, questionIndex) => {
      const questionErrors = {}

      questionErrors.value = required(question.value)
      questionsArrayErrors[questionIndex] = questionErrors
    })

    errors.questionOptions = questionsArrayErrors
  }

  return errors
}
